export default "__VITE_ASSET__CYOfLNmg__"